import { useEffect, useMemo } from 'react';
import { ApolloError, useLazyQuery } from '@apollo/client';
import { ThreadMessage } from '@assistant-ui/react';

import { AI_CHAT_MESSAGES } from '@atom/graph/ai';
import {
  AIChatMessageConnection,
  AIChatMessageConnectionInput,
} from '@atom/types/ai';

export type UseMessagesResponse = {
  messages: ThreadMessage[];
  loading: boolean;
  error?: ApolloError | null;
};

export const useMessages = (threadId: string) => {
  const [getMessages, { data, error, loading }] = useLazyQuery<
    { aiChatMessages: AIChatMessageConnection },
    { input: AIChatMessageConnectionInput }
  >(AI_CHAT_MESSAGES, {
    fetchPolicy: 'no-cache',
  });

  useEffect(() => {
    if (threadId) {
      getMessages({ variables: { input: { threadId } } });
    }
  }, [threadId]);

  const messages = useMemo(() => {
    if (!data?.aiChatMessages) {
      return [];
    }

    return data.aiChatMessages.messages.map(message => {
      return {
        ...message,
        content: message.parts,
      } as unknown as ThreadMessage;
    });
  }, [data]);

  return useMemo<UseMessagesResponse>(
    () => ({
      loading,
      error,
      messages,
    }),
    [loading, error, messages],
  );
};
